import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/icons/expand-arrows-alt-solid.svg'
import _imports_1 from './../../assets/icons/bed-solid.svg'
import _imports_2 from './../../assets/icons/bath-solid.svg'
import _imports_3 from './../../assets/icons/car-side-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-8f993b46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-2 unit-title" }
const _hoisted_2 = { class: "unit-image-container" }
const _hoisted_3 = {
  key: 0,
  class: "enlarge-icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "sold-out-banner"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "SOLD OUT", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "layout-details" }
const _hoisted_10 = {
  key: 0,
  class: "px-2 unit-config"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bed-icon",
  src: _imports_1
}, null, -1))
const _hoisted_12 = { class: "unit-config-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bath-icon",
  src: _imports_2
}, null, -1))
const _hoisted_14 = { class: "unit-config-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "car-icon",
  src: _imports_3
}, null, -1))
const _hoisted_16 = { class: "unit-config-text" }
const _hoisted_17 = {
  key: 1,
  class: "px-2 unit-config"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<img class=\"bed-icon\" src=\"" + _imports_1 + "\" data-v-8f993b46><span class=\"unit-config-text\" data-v-8f993b46> N/A </span><img class=\"bath-icon\" src=\"" + _imports_2 + "\" data-v-8f993b46><span class=\"unit-config-text\" data-v-8f993b46> N/A </span><img class=\"car-icon\" src=\"" + _imports_3 + "\" data-v-8f993b46><span class=\"unit-config-text\" data-v-8f993b46> N/A </span>", 6)
const _hoisted_24 = [
  _hoisted_18
]
const _hoisted_25 = {
  key: 2,
  class: "unit-desc px-2 pb-3"
}
const _hoisted_26 = { class: "row px-2 pb-3" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 unit-details-title" }, "Size", -1))
const _hoisted_30 = { class: "col-9 unit-details-content" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 unit-details-title" }, "Price", -1))
const _hoisted_34 = { class: "col-9 unit-details-content" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 unit-details-title" }, "Instalment", -1))
const _hoisted_37 = { class: "col-9 unit-details-content" }
const _hoisted_38 = {
  key: 3,
  class: "col px-2"
}
const _hoisted_39 = { class: "col-12 contact-me-text" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_41 = { class: "contact-me-button" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" to know more on promotional packages, units availability or loan eligibility. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageContainerWithModal = _resolveComponent("ImageContainerWithModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.unit.availableUnits === 0 ? 'layout sold-out' : 'layout')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.unit.name), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.unit.images && _ctx.unit.images.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.unit.availableUnits === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_ImageContainerWithModal, {
        class: "unit-image",
        images: _ctx.unit.images || [],
        id: _ctx.unit._id
      }, null, 8, ["images", "id"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.unit.configuration && _ctx.unit.configuration.use)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.unit.configuration.bedroom +
          (_ctx.unit.configuration.smallroom > 0
            ? ' + ' + _ctx.unit.configuration.smallroom
            : '')), 1),
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.unit.configuration.bathroom), 1),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.unit.configuration.carpark), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.unit.configuration || !_ctx.unit.configuration.use)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_24))
        : _createCommentVNode("", true),
      (_ctx.unit.desc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("span", null, _toDisplayString(_ctx.unit.desc), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.getUnitSizes(_ctx.unit)) + " " + _toDisplayString(_ctx.unit.configuration && _ctx.unit.configuration.floor > 1
                  ? '(' + _ctx.unit.configuration.floor + ' storeys)'
                  : ''), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.getUnitPrice(_ctx.unit)), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.getUnitMonthlyLoan(_ctx.unit)) + "* ", 1)
          ])
        ])
      ]),
      (_ctx.unit.availableUnits !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onContactMe(_ctx.unit)))
                }, " Contact Me ")
              ]),
              _hoisted_42
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}